"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieHttpAuthenticationProvider = void 0;
var CookieHttpAuthenticationProvider = /** @class */ (function () {
    function CookieHttpAuthenticationProvider() {
    }
    CookieHttpAuthenticationProvider.prototype.setAuthenticationData = function (config) {
        config.withCredentials = true;
    };
    return CookieHttpAuthenticationProvider;
}());
exports.CookieHttpAuthenticationProvider = CookieHttpAuthenticationProvider;
